import { takeLatest } from 'redux-saga/effects';
import { joinFairPlay } from './joinFairPlay';
import { JOIN_FAIR_PLAY_INIT } from '../../reducers';

export function* fairPlaySagas() {
  yield takeLatest([JOIN_FAIR_PLAY_INIT], joinFairPlay);
}
